/**
 * Custom InternalError class
 * @extends Error
 * @export
 */
export class InternalError extends Error {
	constructor(
		public name: string = 'unknown_error',
		public message: string = 'No further error provided',
		public status: number = 500,
	) {
		super();
	}
}

/**
 * Not implemented error
 * @extends InternalError
 * @export
 */
export class NotImplementedError extends InternalError {
	constructor(message?: string) {
		super('not_implemented', message ?? 'Feature not yet implemented, no further error provided', 501);
	}
}

/**
 * Invalid state error
 * @extends InternalError
 * @export
 */
export class InvalidStateError extends InternalError {
	constructor(message?: string) {
		super('invalid_state', message ?? 'Invalid state with no further error provided', 400);
	}
}

/**
 * Permission error
 * @extends InternalError
 * @export
 */
export class PermissionError extends InternalError {
	constructor(message?: string) {
		super('no_permission', message ?? 'No permission to perform this action', 403);
	}
}
